import useMap from 'react-use/lib/useMap'

const useAsyncList = (
  actions = []
) => {
  const [map, { set, reset }] = useMap(
    actions
  )

  return [map, { set, reset }]
}
export default useAsyncList
